import { useChat } from '../store';

interface TypingIndicatorProps {
  conversationId: string;
}

export function TypingIndicator({ conversationId }: TypingIndicatorProps) {
  const me = useChat((s) => s.me);
  const typingIds = useChat((s) => s.typingByConv[conversationId]) ?? [];
  const conversation = useChat((s) =>
    s.conversations.find((c) => c.id === conversationId),
  );

  const others = typingIds.filter((id) => id !== me?.id);
  if (others.length === 0 || !conversation) return null;

  const names = others
    .map((id) => {
      const p = conversation.participants.find((x) => x.id === id);
      return p?.displayName ?? p?.email?.split('@')[0] ?? 'Someone';
    })
    .slice(0, 3);

  let label: string;
  if (names.length === 1) label = `${names[0]} is typing…`;
  else if (names.length === 2) label = `${names[0]} and ${names[1]} are typing…`;
  else label = `${names.length} people are typing…`;

  return (
    <div className="px-4 pb-1 text-xs text-zinc-500 italic h-5">{label}</div>
  );
}
